var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6578 20.0001H1.34229C0.662238 20.0001 0.113281 19.4511 0.113281 18.771V1.22901C0.113281 0.548957 0.662238 0 1.34229 0H31.6578C32.3379 0 32.8868 0.548957 32.8868 1.22901V18.771C32.8868 19.4511 32.3379 20.0001 31.6578 20.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2232 0.638242C15.7218 0.638242 19.2163 0.650532 22.7148 0.630049C23.6735 0.625952 24.6362 0.617759 25.5948 0.605469C25.6767 0.605469 25.7587 0.617759 25.8406 0.621856C26.2298 0.654629 26.3322 0.970075 26.4101 1.29781C27.2376 4.75542 26.9754 8.43835 25.5047 11.6952C25.1155 12.5637 24.6362 13.379 24.1077 14.1655C23.6939 14.7841 23.2392 15.374 22.7476 15.9353C22.3789 16.3532 21.9897 16.7505 21.5801 17.1233C20.8058 17.8239 19.9823 18.463 19.0237 18.9013C18.5157 19.1348 17.9832 19.2823 17.426 19.3601C16.873 19.438 16.3158 19.438 15.7627 19.4257C12.6984 19.3601 9.63 19.4093 6.56567 19.397C4.98025 19.3888 3.39074 19.397 1.80532 19.397C1.64145 19.397 1.47758 19.3847 1.31781 19.3315C0.994171 19.2249 0.793433 18.9423 0.777046 18.5613C0.772949 18.4548 0.772949 18.3482 0.772949 18.2376C0.772949 12.7358 0.772949 7.23392 0.772949 1.73206C0.772949 1.57639 0.777046 1.41661 0.805723 1.26094C0.879463 0.884044 1.17852 0.658726 1.55951 0.634146C1.69061 0.625952 1.8258 0.630049 1.95689 0.630049C5.38173 0.638242 8.80247 0.638242 12.2232 0.638242Z",
    fill: "#2F4653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3033 15.5617C26.4917 15.5085 26.6474 15.402 26.7949 15.2832C27.4135 14.7875 27.8764 14.1607 28.2697 13.4765C29.6872 11.0103 30.5229 8.24505 30.6867 5.39375C30.7031 5.10289 30.7072 4.81202 30.7154 4.52525C30.7154 4.48019 30.7072 4.43513 30.7441 4.39006C30.8588 4.42283 30.9571 4.48019 31.0514 4.55803C32.1493 5.53304 32.3377 7.38065 32.2148 8.74485C31.9321 11.9771 30.146 15.4306 27.2783 17.1021C27.2128 17.139 27.1472 17.1799 27.0776 17.2127C26.6351 17.4503 26.1763 17.6347 25.7011 17.7944C25.6109 17.8231 25.5208 17.8559 25.4348 17.8846C25.824 17.8641 26.3647 17.7944 26.9751 17.5937C28.6097 17.057 29.9125 15.8444 30.8178 14.4065C31.0391 14.0542 31.2398 13.6896 31.4364 13.3209C31.4487 13.3004 31.461 13.2758 31.4897 13.2676C31.5266 13.2676 31.5389 13.2963 31.5512 13.3249C32.0059 14.3737 31.8871 15.4511 31.248 16.3975C29.9862 18.2656 27.3234 19.3758 25.1193 19.3881C23.0874 19.3962 21.0595 19.3922 19.0276 19.3922C18.962 19.3922 18.8678 19.4249 18.8473 19.3348C18.8268 19.2406 18.9333 19.2488 18.9907 19.2242C22.0714 17.8067 24.4024 15.3364 25.9223 12.3213C27.2414 9.69938 27.9051 6.73337 27.647 3.79604C27.5651 2.8538 27.3889 1.92385 27.1226 1.01848C27.1062 0.965226 27.0858 0.911969 27.0735 0.854615C27.0366 0.657974 27.0939 0.608814 27.2947 0.629297C27.7945 0.678457 28.2328 0.862809 28.6261 1.17006C29.3676 1.75589 29.6544 2.81283 29.8223 3.70182C30.1419 5.36917 29.8142 7.21268 29.425 8.84317C28.917 10.9653 28.0608 13.0382 26.8277 14.8448C26.6966 15.0374 26.545 15.2135 26.4016 15.402C26.3729 15.4552 26.3402 15.5085 26.3033 15.5617Z",
    fill: "url(#paint0_linear_945_12820)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74907 8.56286C8.74497 8.30067 8.66304 8.03848 8.43362 7.891C8.2083 7.74761 7.90925 7.75171 7.73309 7.96884C7.7208 7.98522 7.68802 8.018 7.69622 8.04258C7.70441 8.06716 7.76176 8.06306 7.78225 8.07535C7.82321 8.09583 7.8396 8.1368 7.83551 8.17777C7.83551 8.22693 7.8355 8.70624 7.83141 9.36171C7.25377 9.35761 6.67204 9.35352 6.09441 9.34942C6.08212 9.20604 6.07802 9.04627 6.09031 8.87011C6.09851 8.71034 6.11899 8.54647 6.15176 8.3867C6.16405 8.31705 6.18044 8.24741 6.20092 8.17777C6.22141 8.10403 6.27467 8.0098 6.27057 7.93197C6.27057 7.91968 6.26647 7.91148 6.26238 7.90329C6.24599 7.88281 6.21731 7.8869 6.19273 7.8951C6.04525 7.93197 5.90187 8.0098 5.78716 8.11222C5.75438 8.14499 5.66016 8.23102 5.57413 8.3826C5.35291 8.77998 5.33243 9.34533 5.33243 9.34533C5.32014 9.70993 5.30785 10.4514 5.69703 11.2216C5.69703 11.2216 5.97151 11.7624 6.3607 11.8935C6.43853 11.918 6.45902 11.9017 6.46721 11.8935C6.49589 11.8525 6.43034 11.787 6.41395 11.7583C6.37708 11.705 6.34841 11.6436 6.32383 11.5862C6.27057 11.4633 6.2337 11.3322 6.20912 11.197C6.12718 10.7956 6.07393 10.3859 6.08622 9.97622H7.8396C7.8396 10.4924 7.8396 11.0086 7.8396 11.5248C7.8396 11.6272 7.88057 11.7255 7.97479 11.7747C8.03215 11.8033 8.09769 11.8156 8.15914 11.8238C8.26975 11.8361 8.38446 11.8443 8.49507 11.8238C8.56062 11.8115 8.62207 11.787 8.67123 11.7419C8.74907 11.6682 8.74907 11.5739 8.74907 11.4756C8.74907 10.6972 8.75726 9.92296 8.75726 9.14459C8.75316 8.94795 8.75316 8.7554 8.74907 8.56286Z",
    fill: "url(#paint1_linear_945_12820)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34851 12.0903C5.63978 11.8814 5.3653 11.1358 5.21372 10.4844C5.18095 10.341 5.14818 10.2018 5.13179 10.0584C5.07443 9.62002 5.07853 9.14071 5.21782 8.71875C5.1113 8.74333 5.06214 8.83755 4.9966 8.91129C4.76718 9.18577 4.7467 9.50941 4.73851 9.82895C4.71393 10.5786 4.98431 11.1112 5.04576 11.2259C5.18505 11.484 5.33253 11.652 5.37759 11.7011C5.53326 11.8773 5.69304 11.9961 5.81594 12.078C5.72171 12.0535 5.58242 12.0084 5.43904 11.9183C5.30385 11.8363 5.20963 11.7421 5.14408 11.6725C5.05395 11.5578 4.9884 11.4512 4.94744 11.3816C4.83683 11.185 4.69344 10.9433 4.6238 10.6196C4.60331 10.5295 4.59102 10.4353 4.55415 10.4312C4.5009 10.4271 4.44354 10.6114 4.43125 10.6524C4.39029 10.7835 4.378 10.9023 4.38209 10.9637C4.38619 11.2095 4.57054 11.6889 5.00889 12.0125C5.00889 12.0125 5.39398 12.2952 6.05354 12.3197C6.08222 12.3197 6.24199 12.3156 6.3567 12.2337C6.40996 12.1846 6.45092 12.1231 6.34851 12.0903Z",
    fill: "url(#paint2_linear_945_12820)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21777 8.71514V8.7192L5.22589 8.70703L5.21777 8.71514Z",
    fill: "url(#paint3_linear_945_12820)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.803 8.47264C17.8071 8.38251 17.803 8.24732 17.7702 8.08755C17.7661 8.07116 17.762 8.0302 17.7415 7.98104C17.7292 7.95646 17.7006 7.88681 17.6268 7.84175C17.5859 7.81717 17.5449 7.80078 17.4998 7.80078C17.4671 7.80078 17.4343 7.80488 17.4056 7.80488C17.3605 7.80488 17.3155 7.80488 17.2745 7.80488C17.1885 7.80488 17.1025 7.80488 17.0164 7.80488C16.9386 7.80897 16.8689 7.83356 16.8116 7.89091C16.746 7.96055 16.6928 8.05478 16.6068 8.2678C16.5904 8.30058 16.5822 8.33335 16.574 8.34974C16.5412 8.41938 16.0783 9.42307 15.9021 9.71394C15.8898 9.73442 15.8612 9.78358 15.8243 9.77948C15.7874 9.77948 15.7587 9.73442 15.7464 9.71394C15.5703 9.42307 15.1074 8.41938 15.0746 8.34974C15.0664 8.32926 15.0541 8.30058 15.0418 8.2678C14.9558 8.05887 14.9025 7.96055 14.837 7.89091C14.7837 7.83356 14.71 7.80897 14.6321 7.80488C14.5461 7.80078 14.4601 7.80488 14.3741 7.80488C14.329 7.80488 14.2839 7.80488 14.243 7.80488C14.2102 7.80488 14.1774 7.80488 14.1487 7.80078C14.1037 7.80078 14.0586 7.81717 14.0217 7.84175C13.948 7.88681 13.9193 7.95646 13.907 7.98104C13.8865 8.0302 13.8825 8.07116 13.8784 8.08755C13.8456 8.24732 13.8415 8.38251 13.8456 8.47264C13.8128 9.50501 13.78 10.5374 13.7432 11.5656C13.7432 11.582 13.7473 11.6066 13.7555 11.6312C13.8087 11.7828 14.0013 11.8565 14.1487 11.8565C14.2962 11.8565 14.4765 11.7869 14.5379 11.6517C14.5379 11.6517 14.5502 11.623 14.5584 11.5943C14.6035 11.3854 14.628 9.69345 14.6362 8.95605C15.0418 9.78358 15.3573 10.4022 15.5006 10.6767C15.5293 10.734 15.5949 10.8446 15.7096 10.8856C15.7424 10.8979 15.7792 10.902 15.8202 10.902C15.8571 10.902 15.8939 10.8938 15.9308 10.8856C16.0455 10.8487 16.1111 10.734 16.1397 10.6767C16.2872 10.4022 16.6027 9.78358 17.0041 8.95605C17.0123 9.69345 17.0369 11.3854 17.082 11.5943C17.0902 11.623 17.0984 11.6517 17.1025 11.6517C17.1639 11.7869 17.3442 11.8606 17.4916 11.8565C17.6391 11.8565 17.8317 11.7787 17.8849 11.6312C17.8931 11.6066 17.8972 11.582 17.8972 11.5656C17.8726 10.5374 17.8358 9.50501 17.803 8.47264Z",
    fill: "url(#paint4_linear_945_12820)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6089 10.9141C10.617 10.9141 10.6252 10.9181 10.6333 10.9181C10.6252 10.9343 10.6049 10.9262 10.6089 10.9141Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9442 7.92873C12.8623 7.82221 12.7148 7.81812 12.5796 7.81402C12.4485 7.80992 12.2847 7.80583 12.1782 7.92054C12.1208 7.98608 12.1044 8.05982 12.1003 8.10489C12.0962 8.86687 12.0962 9.62886 12.0921 10.3908C12.0921 10.4646 12.088 10.6039 12.0102 10.7595C11.9324 10.9234 11.8176 11.0135 11.789 11.0381C11.789 11.0381 11.5964 11.1897 11.3465 11.2102C11.3219 11.2102 11.2933 11.2143 11.2933 11.2143C11.2851 11.2143 11.281 11.2143 11.2728 11.2143C11.2646 11.2143 11.2605 11.2143 11.2523 11.2143C11.2523 11.2143 11.2277 11.2143 11.199 11.2102C10.9491 11.1897 10.7566 11.0381 10.7566 11.0381C10.7279 11.0135 10.6132 10.9234 10.5354 10.7595C10.4616 10.6039 10.4534 10.4646 10.4534 10.3908C10.4493 9.62886 10.4493 8.86687 10.4453 8.10489C10.4412 8.05982 10.4248 7.98199 10.3674 7.92054C10.265 7.80583 10.097 7.80992 9.96594 7.81402C9.82665 7.81812 9.68327 7.82221 9.60133 7.92873C9.53579 8.01066 9.53988 8.11308 9.54398 8.15814C9.54398 8.957 9.54398 9.75176 9.54398 10.5506C9.54398 10.7718 9.60953 11.0668 9.82255 11.3495C10.0602 11.6649 10.4043 11.8042 10.5067 11.8411C10.7197 11.9189 10.9287 11.9435 10.9942 11.9476C11.1048 11.9599 11.199 11.9599 11.2687 11.9558C11.3383 11.9599 11.4326 11.9558 11.5432 11.9476C11.6087 11.9394 11.8176 11.9189 12.0307 11.8411C12.1372 11.8001 12.4772 11.6608 12.7148 11.3495C12.9278 11.0709 12.9934 10.7759 12.9934 10.5506C12.9934 9.75176 12.9934 8.957 12.9934 8.15814C13.0057 8.11308 13.0098 8.01066 12.9442 7.92873Z",
    fill: "url(#paint5_linear_945_12820)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8057 11.9023C10.8138 11.9023 10.8178 11.9064 10.8259 11.9064L10.8138 11.9145L10.8057 11.9023Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4319 9.07237C22.3172 8.68728 22.0796 8.35135 21.7601 8.10965C21.3955 7.83517 20.9448 7.69179 20.4942 7.68359C20.0394 7.69588 19.5929 7.83927 19.2283 8.10965C18.9088 8.35135 18.6712 8.68728 18.5564 9.07237C18.2287 10.1744 18.7244 11.5795 19.9084 11.8909C20.1009 11.9401 20.2975 11.9605 20.4942 11.9564C20.6908 11.9605 20.8875 11.9401 21.08 11.8909C22.2639 11.5836 22.7596 10.1744 22.4319 9.07237ZM21.547 10.3055C21.4241 10.8258 21.0759 11.387 20.4901 11.3952C19.9043 11.3911 19.556 10.8299 19.4331 10.3055C19.3143 9.80158 19.3348 9.21166 19.6175 8.76102C19.8141 8.44967 20.146 8.26532 20.4901 8.26532C20.8383 8.26942 21.1701 8.45377 21.3627 8.76102C21.6454 9.21166 21.6699 9.80158 21.547 10.3055Z",
    fill: "url(#paint6_linear_945_12820)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_945_12820",
    x1: 17.3687,
    y1: 12.8749,
    x2: 32.6175,
    y2: 8.19384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_945_12820",
    x1: 7.90989,
    y1: 10.3023,
    x2: 5.10175,
    y2: 8.17722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_945_12820",
    x1: 6.86105,
    y1: 11.6886,
    x2: 4.05292,
    y2: 9.56354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_945_12820",
    x1: 7.67214,
    y1: 10.5661,
    x2: 4.89191,
    y2: 8.46216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_945_12820",
    x1: 18.3132,
    y1: 11.1691,
    x2: 13.9492,
    y2: 8.85428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_945_12820",
    x1: 13.4238,
    y1: 10.9556,
    x2: 9.0598,
    y2: 8.22337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_945_12820",
    x1: 23.5695,
    y1: 11.6202,
    x2: 18.143,
    y2: 8.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumoLogo);
export default __webpack_public_path__ + "static/media/humo-logo.817044637f74dd47b88d905f16406718.svg";
export { ForwardRef as ReactComponent };